/*
 * The contact page. Same reading column and the same rhythm as LegalPage, because the
 * three prose pages of this site should look like one another rather than like three
 * designs. The one thing that is louder here is the address itself: it is the reason
 * anybody opens this page.
 */

.article {
  padding-block: clamp(38px, 6vw, 68px) clamp(40px, 6vw, 72px);
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.back {
  font-size: 14px;
  color: var(--ink-muted);
  align-self: flex-start;
  padding-block: 8px;
}

.back:hover {
  color: var(--ink);
}

.title {
  margin-top: 8px;
  font-size: clamp(34px, 5vw, 48px);
  line-height: 1.1;
  color: var(--ink);
}

.lede {
  margin-top: 6px;
  font-family: var(--font-display);
  font-size: 18px;
  line-height: 1.6;
  color: var(--ink-body);
}

/* The address block: a tile, so it is the first thing the eye lands on. */
.mail {
  margin-top: 18px;
  padding: 22px 24px;
  background: var(--paper-raised);
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.mailTitle {
  font-size: 20px;
  color: var(--ink);
}

.address {
  font-family: var(--font-display);
  font-size: clamp(20px, 3vw, 26px);
  line-height: 1.3;
  color: var(--ink);
  text-decoration: underline;
  text-underline-offset: 4px;
  align-self: flex-start;
  /* A 44px target, the same floor the app uses for anything you tap. */
  padding-block: 10px;
  word-break: break-word;
}

.note {
  font-size: 15px;
  line-height: 1.7;
  color: var(--ink-muted);
}

.section,
.care {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 24px;
  border-top: 1px solid var(--rule);
}

.sectionTitle {
  font-size: 24px;
  color: var(--ink);
}

.body {
  font-size: 16px;
  line-height: 1.7;
  color: var(--ink-muted);
}

.points {
  margin: 4px 0 0;
  padding-left: 22px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 16px;
  line-height: 1.7;
  color: var(--ink-muted);
  list-style: disc;
}

.links {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 26px;
  font-size: 16px;
  color: var(--ink);
}

.links a {
  text-decoration: underline;
  text-underline-offset: 4px;
  padding-block: 8px;
}

.org {
  margin-top: 26px;
  padding: 20px 22px;
  background: var(--paper-raised);
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.orgTitle {
  font-size: 20px;
  color: var(--ink);
  margin-bottom: 4px;
}

.orgLine {
  font-size: 16px;
  line-height: 1.6;
  color: var(--ink-body);
}

.orgLink {
  font-size: 16px;
  line-height: 1.6;
  color: var(--ink-body);
  text-decoration: underline;
  text-underline-offset: 3px;
  align-self: flex-start;
  padding-block: 8px;
}

.orgLink:hover {
  color: var(--ink);
}
